import Typography from "antd/es/typography/Typography";
import React from "react";
import ReactApexChart from "react-apexcharts";

const TechChart = ({ technologyFrequency }) => {
  const { Title } = Typography;
  const sortedTechEntries = Object.entries(technologyFrequency).sort(
    (a, b) => b[1] - a[1]
  );

  const visibleTechEntries = sortedTechEntries.slice(0, 12);
  const techNames = visibleTechEntries.map(([name]) => name);
  const techCounts = visibleTechEntries.map(([, count]) => count);
  const totalTechnologies = sortedTechEntries.length;

  if (!techNames.length) {
    return <div className="dashboard-empty-state">No technology data yet.</div>;
  }

  const chartHeight = Math.max(360, techNames.length * 42);

  const options = {
    series: [
      {
        data: techCounts,
      },
    ],
    chart: {
      height: chartHeight,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: ["#5FCBA0"],
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        barHeight: "58%",
        distributed: false,
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: 10,
      style: {
        colors: ["#345a4a"],
        fontWeight: 700,
      },
    },
    legend: {
      show: false,
    },
    grid: {
      borderColor: "rgba(74, 108, 95, 0.12)",
      strokeDashArray: 4,
    },
    xaxis: {
      categories: techNames,
      labels: {
        style: {
          colors: ["#688178"],
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      labels: {
        maxWidth: 220,
        style: {
          colors: techNames.map(() => "#355f4f"),
          fontSize: "12px",
          fontWeight: 600,
        },
      },
    },
    tooltip: {
      y: {
        formatter(value) {
          return value;
        },
      },
    },
  };

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Stack Signals</span>
          <Title level={5}>Top Technologies &amp; Tools</Title>
          <span className="dashboard-panel__subtext">
            Ranked by frequency across submitted expert profiles. Showing the
            top 12 when the dataset is large.
          </span>
        </div>
        <span className="dashboard-panel__metric">{totalTechnologies}</span>
      </div>
      <div className="dashboard-panel__chart">
        <div className="dashboard-panel__chart-inner dashboard-panel__chart-inner--fluid">
        <ReactApexChart
          options={options}
          series={options.series}
          type="bar"
          height={chartHeight}
        />
        </div>
      </div>
    </div>
  );
};

export default TechChart;
